var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('size-table',{attrs:{"row-header-fallback":_vm.bp('size')}})}
var staticRenderFns = []

export { render, staticRenderFns }